module.exports = __webpack_public_path__ + "img/chahua1.b4f8f571.png";